import React from 'react';
import { compose } from 'ramda';
import styled from 'styled-components/macro';
import Grid from '@material-ui/core/Grid';
import { Typography, Button } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { RouteComponentProps } from 'react-router-dom';

const { withRouter } = RouterProvider;

const StyledLogo = styled(Logo)`
  color: #1f5dea;
  width: 300px;
  margin-bottom: 32px;
`;

const NoMatch = ({ history }: RouteComponentProps) => {
  const t = useFormatMessage();
  setTimeout(function () {
    history.push('/');
  }, 10000);
  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      style={{ height: '100vh' }}
    >
      <StyledLogo />
      <Typography variant={'h5'}>404</Typography>
      <Typography variant={'copy1'} mt={3}>
        {t('pages.notfound', "Whoops, we can't find this page")}
      </Typography>
      <Button onClick={() => history.push('/')} mt="2rem">
        GO TO HOMEPAGE
      </Button>
    </Grid>
  );
};

export default compose(withRouter)(NoMatch);
